/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ContractAdjustmentPayloadDto
 */
export interface ContractAdjustmentPayloadDto {
    /**
     * 
     * @type {Date}
     * @memberof ContractAdjustmentPayloadDto
     */
    transactionDate: Date;
    /**
     * 
     * @type {string}
     * @memberof ContractAdjustmentPayloadDto
     */
    adjustmentType: ContractAdjustmentPayloadDtoAdjustmentTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof ContractAdjustmentPayloadDto
     */
    expiryDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof ContractAdjustmentPayloadDto
     */
    inceptionDate: Date;
    /**
     * 
     * @type {string}
     * @memberof ContractAdjustmentPayloadDto
     */
    brokerReference?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractAdjustmentPayloadDto
     */
    premiumPaymentWarranty?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractAdjustmentPayloadDto
     */
    underwritingComments?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractAdjustmentPayloadDto
     */
    tiv?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractAdjustmentPayloadDto
     */
    premiumAdjustmentAmount?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractAdjustmentPayloadDto
     */
    cedingCommissionRate?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractAdjustmentPayloadDto
     */
    gstRateOnCedingCommission?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractAdjustmentPayloadDto
     */
    sourceBrokerageRate?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractAdjustmentPayloadDto
     */
    ereRate?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractAdjustmentPayloadDto
     */
    withholdingTaxRate?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractAdjustmentPayloadDto
     */
    aitRate?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractAdjustmentPayloadDto
     */
    taxAndFeeAmount?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractAdjustmentPayloadDto
     */
    otherDeductions?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractAdjustmentPayloadDto
     */
    gstOnEre?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractAdjustmentPayloadDto
     */
    gstRateOnSourceBrokerage?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractAdjustmentPayloadDto
     */
    gstRateOnPremium?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractAdjustmentPayloadDto
     */
    binderShareSigned?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ContractAdjustmentPayloadDto
     */
    fileIds?: Array<string>;
}


/**
 * @export
 */
export const ContractAdjustmentPayloadDtoAdjustmentTypeEnum = {
    PolicyExtension: 'Policy Extension',
    PremiumAdjustment: 'Premium Adjustment',
    Cancellation: 'Cancellation',
    RateUpdate: 'Rate Update',
    StockAdjustment: 'Stock Adjustment',
    NonFinancialEndorsement: 'Non-Financial Endorsement'
} as const;
export type ContractAdjustmentPayloadDtoAdjustmentTypeEnum = typeof ContractAdjustmentPayloadDtoAdjustmentTypeEnum[keyof typeof ContractAdjustmentPayloadDtoAdjustmentTypeEnum];


/**
 * Check if a given object implements the ContractAdjustmentPayloadDto interface.
 */
export function instanceOfContractAdjustmentPayloadDto(value: object): value is ContractAdjustmentPayloadDto {
    if (!('transactionDate' in value) || value['transactionDate'] === undefined) return false;
    if (!('adjustmentType' in value) || value['adjustmentType'] === undefined) return false;
    if (!('expiryDate' in value) || value['expiryDate'] === undefined) return false;
    if (!('inceptionDate' in value) || value['inceptionDate'] === undefined) return false;
    return true;
}

export function ContractAdjustmentPayloadDtoFromJSON(json: any): ContractAdjustmentPayloadDto {
    return ContractAdjustmentPayloadDtoFromJSONTyped(json, false);
}

export function ContractAdjustmentPayloadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContractAdjustmentPayloadDto {
    if (json == null) {
        return json;
    }
    return {
        
        'transactionDate': (new Date(json['transactionDate'])),
        'adjustmentType': json['adjustmentType'],
        'expiryDate': (new Date(json['expiryDate'])),
        'inceptionDate': (new Date(json['inceptionDate'])),
        'brokerReference': json['brokerReference'] == null ? undefined : json['brokerReference'],
        'premiumPaymentWarranty': json['premiumPaymentWarranty'] == null ? undefined : json['premiumPaymentWarranty'],
        'underwritingComments': json['underwritingComments'] == null ? undefined : json['underwritingComments'],
        'tiv': json['tiv'] == null ? undefined : json['tiv'],
        'premiumAdjustmentAmount': json['premiumAdjustmentAmount'] == null ? undefined : json['premiumAdjustmentAmount'],
        'cedingCommissionRate': json['cedingCommissionRate'] == null ? undefined : json['cedingCommissionRate'],
        'gstRateOnCedingCommission': json['gstRateOnCedingCommission'] == null ? undefined : json['gstRateOnCedingCommission'],
        'sourceBrokerageRate': json['sourceBrokerageRate'] == null ? undefined : json['sourceBrokerageRate'],
        'ereRate': json['ereRate'] == null ? undefined : json['ereRate'],
        'withholdingTaxRate': json['withholdingTaxRate'] == null ? undefined : json['withholdingTaxRate'],
        'aitRate': json['aitRate'] == null ? undefined : json['aitRate'],
        'taxAndFeeAmount': json['taxAndFeeAmount'] == null ? undefined : json['taxAndFeeAmount'],
        'otherDeductions': json['otherDeductions'] == null ? undefined : json['otherDeductions'],
        'gstOnEre': json['gstOnEre'] == null ? undefined : json['gstOnEre'],
        'gstRateOnSourceBrokerage': json['gstRateOnSourceBrokerage'] == null ? undefined : json['gstRateOnSourceBrokerage'],
        'gstRateOnPremium': json['gstRateOnPremium'] == null ? undefined : json['gstRateOnPremium'],
        'binderShareSigned': json['binderShareSigned'] == null ? undefined : json['binderShareSigned'],
        'fileIds': json['fileIds'] == null ? undefined : json['fileIds'],
    };
}

export function ContractAdjustmentPayloadDtoToJSON(json: any): ContractAdjustmentPayloadDto {
    return ContractAdjustmentPayloadDtoToJSONTyped(json, false);
}

export function ContractAdjustmentPayloadDtoToJSONTyped(value?: ContractAdjustmentPayloadDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'transactionDate': ((value['transactionDate']).toISOString()),
        'adjustmentType': value['adjustmentType'],
        'expiryDate': ((value['expiryDate']).toISOString()),
        'inceptionDate': ((value['inceptionDate']).toISOString()),
        'brokerReference': value['brokerReference'],
        'premiumPaymentWarranty': value['premiumPaymentWarranty'],
        'underwritingComments': value['underwritingComments'],
        'tiv': value['tiv'],
        'premiumAdjustmentAmount': value['premiumAdjustmentAmount'],
        'cedingCommissionRate': value['cedingCommissionRate'],
        'gstRateOnCedingCommission': value['gstRateOnCedingCommission'],
        'sourceBrokerageRate': value['sourceBrokerageRate'],
        'ereRate': value['ereRate'],
        'withholdingTaxRate': value['withholdingTaxRate'],
        'aitRate': value['aitRate'],
        'taxAndFeeAmount': value['taxAndFeeAmount'],
        'otherDeductions': value['otherDeductions'],
        'gstOnEre': value['gstOnEre'],
        'gstRateOnSourceBrokerage': value['gstRateOnSourceBrokerage'],
        'gstRateOnPremium': value['gstRateOnPremium'],
        'binderShareSigned': value['binderShareSigned'],
        'fileIds': value['fileIds'],
    };
}

